import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import CustomModal from "../packages/CustomModal";
import { useToastNotification } from "../packages/WPToastNotification";
import WPMessageBanner from "../packages/WPMessageBanner/WPMessageBanner";

import InputBox from "../components/InputBox";

import { CustomModalButtons } from "../constants/global.constants";

import { getPlants, sharePlant } from "../network/cipAPI";

import { storePlantRowData } from "../Store/TemplateStore/template.action";

import "./index.scss";

const ShareDialog = ({ setShareDialogOpen, shareDialogOpen, plantId }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [comments, setComments] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const isPlantsRefreshInFlightRef = useRef(false);

  const dispatch = useDispatch();
  const { showSuccessNotification, showErrorNotification } =
    useToastNotification();

  const getPlantDetails = async () => {
    if (isPlantsRefreshInFlightRef.current) {
      return;
    }

    isPlantsRefreshInFlightRef.current = true;
    try {
      const response = await getPlants();
      if (response && response.data) {
        dispatch(storePlantRowData(response.data));
      } else {
        dispatch(storePlantRowData([]));
      }
    } catch (err) {
    } finally {
      isPlantsRefreshInFlightRef.current = false;
    }
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      const payload = { shared_email: email, comments };
      const response = await sharePlant(plantId, payload);

      if (response && response.message) {
        setShareDialogOpen(false);
        showSuccessNotification(response.message);
        getPlantDetails();
      } else {
        showErrorNotification(response.detail.error);
        setErrorMsg(response.detail.error);
      }
    } catch (error) {
      showErrorNotification(t("notificationStrings.somethingWrong"));
    } finally {
      setIsLoading(false);
    }
  };

  // Remove if unshare functionality is never going to be in future scope.
  // const handleUnshare = async () => {
  //   setShowOverlayLoader(true);
  //   try {
  //     const response = await unsharePlant(plantId, email);
  //     if (response && response.message) {
  //       setShareDialogOpen(false);
  //       createNotification(SUCCESS_NOTIFICATION, response.message, "");
  //       getPlantDetails();
  //     } else {
  //       createNotification(ERROR_NOTIFICATION, response.detail.error, "");
  //       setShareDialogOpen(false);
  //     }
  //   } catch (error) {
  //     console.error("Error during sharing plant:", error);
  //   } finally {
  //     setShowOverlayLoader(false);
  //   }
  // };

  const onClose = ({ target } = {}) => {
    if (target?.id === CustomModalButtons.CONFIRM) {
      handleConfirm();
    } else if (
      target?.id === CustomModalButtons.CANCEL ||
      target?.id === CustomModalButtons.CLOSE
    ) {
      setEmail("");
      setComments("");
      setErrorMsg("");
      setShareDialogOpen(false);
      getPlantDetails();
    }
  };

  const handleChange = (value) => {
    setEmail(value);
    if (value.trim() === "") {
      setErrorMsg(t("sharePlant.emptyErrorMessage"));
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setErrorMsg([t("sharePlant.invalidEmail")]);
    } else {
      setErrorMsg("");
    }
  };
  const handleCommentsChange = (value) => {
    setComments(value);
  };

  return (
    <>
      {shareDialogOpen && (
        <CustomModal
          onModalClose={onClose}
          cancelBtn={t("ValueStrings.cancel")}
          header={t("sharePlant.title")}
          headerHelper={t("sharePlant.subTitle")}
          confirmBtn={t("ValueStrings.share")}
          width="650px"
          isLoading={isLoading}
          confirmBtnDisabled={!email || errorMsg}
          size="small"
        >
          <div>
            <WPMessageBanner
              message={t("sharePlant.licenseNote")}
              type="note"
            ></WPMessageBanner>
            <div className="share marginTop10">
              {t("sharePlant.userMsg")} <span style={{ color: "red" }}>*</span>
            </div>
            <InputBox
              placeholder={t("sharePlant.enterEmail")}
              onChange={handleChange}
              maxLength={254}
            />

            <div
              style={{
                color: errorMsg ? "red" : "grey",
                textAlign: "left",
                marginTop: "10px",
              }}
            >
              {errorMsg || t("sharePlant.roUser")}
            </div>
            <div className="share marginTop10">{t("sharePlant.comments")}</div>
            <InputBox
              placeholder={t("sharePlant.comments")}
              rows={3}
              maxLength={225}
              onChange={handleCommentsChange}
            />
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default ShareDialog;
